module.exports = __webpack_public_path__ + "img/ic_haven.8d34d1bf.webp";